export function computeAmplitude(minValue, maxValue) {
  return maxValue - minValue;
}
export function computeQuartilePercentageVariance(minValue, minSectionValue, maxSectionValue, maxValue) {
  return computeAmplitude(minSectionValue, maxSectionValue) / computeAmplitude(minValue, maxValue) * 100;
}
const dynamicPinVerticalPositionStyle = "\n  position: absolute;\n  filter: drop-shadow(var(--shadow-level-1));\n  top: calc((-1 * var(--spacing-1) - 1px));\n";
/*
  Computa a posição do pin baseado nos seguintes parâmetros:
  quartileIndex: índice do quartil atual (o que contém o preço do anúncio)
  price: preço do anúncio;
  olxPrice: objeto que contém os delimitadores de preço

  Como funciona essa função:
  Essa função computa o pinStepSize baseado na área válida do tooltip e do quartil. Depois
  computa o número de passos para mover o pin.
  O centro do quartil é diferente dos outros, ele começa no meio e o pin pode ir para frente
  ou para trás.
 */
export default function computePinPositionStyleDynamically(quartileIndex, price, olxPrice) {
  const quartileMinPosition = 16;
  const quartileMaxPosition = 100 - 16;
  const pinWidth = 11;
  const tooltipValidAmplitude = computeAmplitude(quartileMinPosition, quartileMaxPosition);
  const quartileCenterPosition = quartileMaxPosition - tooltipValidAmplitude / 2 - pinWidth / 2;
  const minPrice = olxPrice.price_min;
  const price33 = olxPrice.price_p33;
  const price50 = olxPrice.price_p50;
  const price66 = olxPrice.price_p66;
  const priceMax = olxPrice.price_max;
  let pinSpacing = 0;
  let quartileDynamicPosition = 0;
  let pinStepSize = 0;
  let steps = 0;
  if (quartileIndex === 0) {
    const firstQuartileAmplitude = computeAmplitude(minPrice, price33);
    if (firstQuartileAmplitude === 0) {
      pinSpacing = quartileCenterPosition;
    } else {
      pinStepSize = tooltipValidAmplitude / firstQuartileAmplitude;
      steps = price - minPrice;
      quartileDynamicPosition = quartileMinPosition + Math.round(steps * pinStepSize);
      pinSpacing = Math.max(quartileMinPosition, Math.min(quartileDynamicPosition, quartileMaxPosition));
    }
  } else if (quartileIndex === 1) {
    const secondQuartileAmplitude = computeAmplitude(price33, price66);
    if (secondQuartileAmplitude === 0) {
      pinSpacing = quartileCenterPosition;
    } else {
      pinStepSize = tooltipValidAmplitude / secondQuartileAmplitude;
      steps = price - price50;
      quartileDynamicPosition = quartileCenterPosition + Math.round(steps * pinStepSize);
      pinSpacing = quartileDynamicPosition > 0 ? Math.min(quartileDynamicPosition, quartileMaxPosition) : Math.max(quartileDynamicPosition, quartileMinPosition);
    }
  } else {
    const lastQuartileAmplitude = computeAmplitude(price66, priceMax);
    if (lastQuartileAmplitude === 0) {
      pinSpacing = quartileCenterPosition;
    } else {
      pinStepSize = tooltipValidAmplitude / lastQuartileAmplitude;
      steps = price - price66;
      quartileDynamicPosition = quartileMinPosition + Math.round(steps * pinStepSize);
      pinSpacing = Math.max(quartileMinPosition, Math.min(quartileDynamicPosition, quartileMaxPosition));
    }
  }
  return "".concat(dynamicPinVerticalPositionStyle, "left: ").concat(pinSpacing, "%;");
}